import React, { useEffect, useState } from "react";
import useCartStore from "../store/cartStore";
import useStatusStore from "../store/statusStore";

import { ShoppingCartIcon } from "@heroicons/react/24/outline";

const Karte = () => {
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [expandedCategory, setExpandedCategory] = useState(null);

    const {
        deliveryAvailable,
        orderAvailable,
        isInDeliveryTime,
        isInPickupTime,
        fetchDeliveryAvailable,
        fetchOrderAvailable,
        fetchIsInDeliveryTime,
        fetchInPickupTime,
    } = useStatusStore();

    const { addItem } = useCartStore();

    const toggleCategory = (categoryId) => {
        setExpandedCategory((prev) =>
            prev === categoryId ? null : categoryId
        );
    };

    // Fetch categories and items from the backend
    const fetchMenu = async () => {
        const response = await fetch(`/api/public/menus/name/Bestellkarte`);
        const data = await response.json();
        setCategories(data.categories);
        setItems(data.items);
    };

    useEffect(() => {
        fetchDeliveryAvailable();
        fetchOrderAvailable();
        fetchIsInDeliveryTime();
        fetchInPickupTime();
        fetchMenu();
    }, []);

    return (
        <>
            {!deliveryAvailable && (
                <div className="bg-red-500 text-white text-center p-2">
                    <p>
                        Lieferung ist zurzeit wegen hoher Auslastung nicht
                        verfügbar. Sie können jedoch zum Abholen bestellen.
                    </p>
                </div>
            )}

            <div className="max-w-7xl mx-auto px-4 py-2 bg-white my-16">
                <div className="flex flex-row justify-center items-center space-x-4 flex-wrap">
                    <h1 className="text-3xl font-bold text-center text-black mt-3">
                        Bestellkarte
                    </h1>
                </div>

                <h2 className="text-lg font-semibold text-gray-800 text-center mb-2">
                    Bestellen Sie zum Liefern von Mittwoch bis Samstag von 17:00
                    bis 21:00 Uhr
                    <br />
                    und sonntags von 16:00 Uhr bis 20:00 Uhr.
                    <br />
                    Abholung ist während der Öffnungszeiten möglich.
                </h2>
                <p className="text-sm md:text-lg text-gray-800 mb-4 text-center">
                    Bitte wählen Sie die gewünschten Speisen und Getränke aus.
                </p>

                {isInPickupTime && !isInDeliveryTime && (
                    <h2 className="text-lg font-semibold text-gray-800 text-center mb-2">
                        Abholung ist möglich.
                    </h2>
                )}

                {!orderAvailable && (
                    <div className="bg-yellow-500 text-white text-center p-2">
                        <p>
                            Bestellungen sind zurzeit nicht möglich. Bitte
                            versuchen Sie es zu einem anderen Zeitpunkt erneut.
                        </p>
                    </div>
                )}
                {orderAvailable && (
                    <div className="min-h-96">
                        <div className="flex justify-center mb-6">
                            <button
                                onClick={() => {
                                    window.location.href = "/checkout";
                                }}
                                className="bg-enedemgreen text-white py-2 px-4 rounded-md hover:bg-green-800"
                            >
                                Zur Kasse
                            </button>
                        </div>
                        {categories.map((category) => (
                            <div key={category._id} className="pb-4">
                                <button
                                    onClick={() => toggleCategory(category._id)}
                                    className="w-full text-left flex justify-between items-center py-2 px-4 text-lg font-semibold bg-gray-100 hover:bg-gray-200 rounded-md"
                                >
                                    <span>{category.title}</span>
                                    <span>
                                        {expandedCategory === category._id
                                            ? "▲"
                                            : "▼"}
                                    </span>
                                </button>
                                {expandedCategory === category._id && (
                                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2">
                                        {items
                                            .filter(
                                                (item) =>
                                                    item.category ===
                                                    category._id
                                            )
                                            .map((item) => (
                                                <div
                                                    key={item._id}
                                                    className="flex flex-col bg-white p-4 border-b mx-2"
                                                >
                                                    {/* Left Section: Title and Description */}
                                                    <div
                                                        key={item._id}
                                                        className="flex flex-row bg-white mx-2"
                                                    >
                                                        {/* Left Section: Title and Description */}
                                                        <div className="flex-1 pr-4">
                                                            <h3 className="text-lg font-semibold text-black">
                                                                {item.title}
                                                            </h3>
                                                            <p className="italic text-gray-700 text-md">
                                                                {
                                                                    item.description
                                                                }
                                                            </p>
                                                        </div>
                                                        <div className="flex-none">
                                                            <ul className="">
                                                                {item.prices.map(
                                                                    (
                                                                        price,
                                                                        index
                                                                    ) => (
                                                                        <li
                                                                            key={
                                                                                index
                                                                            }
                                                                            className="flex justify-between text-black"
                                                                        >
                                                                            <span className="text-md">
                                                                                {
                                                                                    price.description
                                                                                }
                                                                            </span>
                                                                            <span className="text-md">
                                                                                {
                                                                                    // Display the price in Euro and 2 decimal places
                                                                                    price.amount.toFixed(
                                                                                        2
                                                                                    )
                                                                                }{" "}
                                                                                €
                                                                            </span>
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-end justify-between mx-2 w-full">
                                                        {!item.sideDish ? (
                                                            <div></div>
                                                        ) : (
                                                            <div
                                                                className={
                                                                    "flex flex-col space-y-2 mt-2 w-1/2"
                                                                }
                                                            >
                                                                <select
                                                                    id={
                                                                        item._id
                                                                    }
                                                                    name="sideDish"
                                                                    defaultValue={
                                                                        "Pommes"
                                                                    }
                                                                    className="p-2 border border-gray-300 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                                >
                                                                    <option value="Pommes">
                                                                        mit
                                                                        Pommes
                                                                    </option>
                                                                    <option value="Reis">
                                                                        mit Reis
                                                                    </option>
                                                                    <option value="Kroketten">
                                                                        mit
                                                                        Kroketten
                                                                    </option>
                                                                    <option value="Kartoffelchips">
                                                                        mit
                                                                        Kartoffelchips
                                                                    </option>
                                                                    <option value="Bandnudeln">
                                                                        mit
                                                                        Bandnudeln
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        )}
                                                        {/* Right Section: Add to Cart with cart symbol */}
                                                        <div className="">
                                                            <button
                                                                onClick={() => {
                                                                    //Get beilage from select
                                                                    var beilage =
                                                                        "";
                                                                    if (
                                                                        item.sideDish
                                                                    ) {
                                                                        beilage =
                                                                            document.getElementById(
                                                                                item._id
                                                                            ).value;
                                                                    }
                                                                    addItem(
                                                                        item._id,
                                                                        item.title,
                                                                        item
                                                                            .prices[0]
                                                                            .amount,

                                                                        item.description,

                                                                        beilage
                                                                    );
                                                                }}
                                                                className="bg-green-500 text-white px-3 py-1 rounded-md hover:bg-green-700"
                                                            >
                                                                <ShoppingCartIcon className="h-5 w-5" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default Karte;
